<section
  class="py-12 sm:py-16 lg:py-24 border-b transition-colors"
  [ngClass]="theme === 'warm' ? 'bg-[#faf6f0] border-stone-200 text-stone-900' : (theme === 'bold' ? 'bg-slate-950 text-white border-blue-900/60' : 'bg-base-100 border-base-300')"
>
  <div class="container mx-auto px-4 sm:px-6 max-w-5xl">
    
    <!-- Heading -->
    <div class="text-center max-w-2xl mx-auto mb-8 sm:mb-10">
      <div
        class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3"
        [ngClass]="theme === 'warm' ? 'bg-amber-500/15 text-amber-900 border border-amber-400/40' : (theme === 'bold' ? 'bg-red-600/20 text-red-300 border border-red-500/40' : 'bg-primary/10 text-primary')"
      >
        <i class="fa-solid fa-play"></i>
        <span>Free Class Demo</span>
      </div>
      <h2
        class="text-2xl sm:text-4xl font-extrabold tracking-tight break-words px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
      >
        {{ title }}
      </h2>
      <p
        class="text-sm sm:text-base mt-3 leading-relaxed px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/70')"
      >
        {{ subtitle }}
      </p>
    </div>

    <!-- Video Frame -->
    <div class="relative w-full rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl border border-base-300 bg-slate-900 aspect-video max-w-4xl mx-auto">
      @if (youtubeEmbedUrl) {
        <iframe
          [src]="youtubeEmbedUrl"
          class="w-full h-full border-0"
          title="Sample Class Lecture Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      } @else if (directVideoUrl) {
        <video
          [src]="directVideoUrl"
          controls
          class="w-full h-full object-cover"
        ></video>
      } @else {
        <!-- Placeholder if no video URL is configured -->
        <div class="w-full h-full flex flex-col items-center justify-center text-center p-6 sm:p-8 text-slate-400">
          <div class="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-white/10 flex items-center justify-center text-white text-xl sm:text-2xl mb-3 sm:mb-4">
            <i class="fa-solid fa-film"></i>
          </div>
          <p class="font-medium text-white text-sm sm:text-base">No demo video configured yet</p>
          <p class="text-xs text-slate-400 mt-1">Paste a YouTube lecture link in the Site Studio editor to show it here.</p>
        </div>
      }
    </div>

  </div>
</section>
